import { SmartComponent } from "smart-component-js";



// TODO REMOVE - logica spostata in jsp
class CardComponent extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    // { isRecipe: true } if needed
    this.isRecipe = params?.isRecipe || false;
    this.init();
  }

  init() {
    if (this.isRecipe) {
      this.showRecipeInfo();
    } else {
      this.showArticleInfo();
    }
  }

  showRecipeInfo() {
    const additionalInfo = this.element.querySelector(".card__additional-info");
    additionalInfo.style.display = "flex"; // Show additional info
  }

  showArticleInfo() {
    const info = this.element.querySelector(".card__info");
    info.style.display = "flex"; // Ensure article info is visible
  }
}

export default CardComponent;
